import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const FleetMySpaceLayout = () => {

  const navList = useNav();
  let {fleetTopHeader, fleetMyDataBottom} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={fleetMyDataBottom} topTabs={fleetTopHeader} />
      <Outlet />
    </div>
  )
}

export default FleetMySpaceLayout